module.exports = __webpack_public_path__ + "img/logo.6700f1c7.png";